// Framework and third-party non-ui
import React, { useContext, useEffect, useState } from 'react';
import { loadModules } from 'esri-loader';
import { fetchFavoriteTrails, fetchFavoriteRoutes } from 'data/map';
import { makeStyles } from '@material-ui/core/styles';

// App components
import { UserContext } from 'contexts/UserContext';
import { MapContext } from 'contexts/MapContext';
import TrailCard from 'components/TrailCard';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FeaturedRoute from 'components/FeaturedRoute';

// JSON & Styles
import { StyledNoResults } from './TrailsList-styled';
import layerConfig from 'configs/AppLayers.json';

// Third-party components (buttons, icons, etc.)
import { Virtuoso } from 'react-virtuoso'
import AutoSizer from 'react-virtualized-auto-sizer';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
  backArrowFlex: {
    display: 'flex',
    fontSize: '16px',
    width: '80%',
    margin: '15px',
  },
  header: {
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
    marginLeft: '15px',
  },
  loading: {
    textAlign: 'center',
  }
});

export default function FavoritedTrailsList () {
  const { userInfo } = useContext(UserContext);
  const { setSidebarSelection, setClickedTab } = useContext(MapContext);
  const [loading, setLoading] = useState(true);
  const [favoritedTrails, setFavoritedTrails] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if(userInfo && userInfo.favoritesUrl){
      (async () => {
        const [esriRequest] = await loadModules(['esri/request']);
        
        let res = await esriRequest(userInfo.favoritesUrl + '/query',{
          method: 'post',
          query: {
            where: '1=1',
            outFields: '*',
            f:"json" // format
          },
         });

         let favoritedTrailIds = res.data.features.filter(feature => !feature.attributes.IsFeaturedTrail).map(feature => feature.attributes.TrailID);
         let fetchedTrails = await fetchFavoriteTrails(favoritedTrailIds);

         let favoritedRouteIds = res.data.features.filter(feature => feature.attributes.IsFeaturedTrail === 1).map(feature => feature.attributes.TrailID);
         let fetchedRoutes = await fetchFavoriteRoutes(favoritedRouteIds);

        setFavoritedTrails(fetchedTrails.concat(fetchedRoutes));
         setLoading(false);
       })();
    }
  }, []);

  const getTrailDifficulty = (difficulty) => {
    if (difficulty === 'Easy') {
      return 'Easy';
    };
    if (difficulty === 'Easiest') {
      return 'Easiest';
    };
    if (difficulty === 'MoreDiff') {
      return 'Moderate';
    };
    if (difficulty === 'VeryDiff') { 
      return 'Difficult';
    };
    if (difficulty === 'ExtmDiff') { 
      return 'Extreme';
    };
    if (difficulty === 'NA') { 
      return 'Not Assessed';
    };
    return 'Not Assessed'
  };

  const getIcons = (attributes) => {
    const attrs = ['WHEELCHAIR_FRIENDLY', 'DOGS', 'SNOWMOBILES', 'BIKES', 'HORSES', 'OFF_ROAD_4X4', 'XC_SKIING', 'STATUS'];
    const icons = {};
    attrs.forEach(attr => {
      if(['Yes', 'Var', 'Recmnd', 'Allow', 'Open'].includes(attributes[attr])){
        icons[attr] = true;
      }else{
        icons[attr] = false;
      }
    });
    return icons;
  };

  const goBackToProfile = () => {
    setSidebarSelection(['Profile']);
    setClickedTab('Profile');
  };

  // if (!favoritedTrails.length) return (<StyledNoResults>Sorry, no favorited trails found...</StyledNoResults>);

  const Row = (index) => {
    if(favoritedTrails[index] && favoritedTrails[index].attributes && (favoritedTrails[index].layer.title === layerConfig.TRAIL_DISSOLVED_TITLE)){
        const attributes = favoritedTrails[index].attributes;
        const geometry = favoritedTrails[index].geometry;
        const difficulty = getTrailDifficulty(attributes.DIFFICULTY);
        const icons = getIcons(attributes);
        return (
          <TrailCard
            key={attributes.PRIMARY_TRAIL_ID}
            difficulty={difficulty}
            length={attributes.Length_SPC}
            attributes={attributes}
            geometry={geometry}
            icons={icons}
            setFavoritedTrails={setFavoritedTrails}
            favoritedTrails={favoritedTrails}
            favorited={true}
            favoriteCard={true}
            loggedIn={userInfo ? true: false}
          />
        );
    }else if(favoritedTrails[index] && favoritedTrails[index].attributes && (favoritedTrails[index].layer.title === layerConfig.FEATURED_ROUTES)){
      const attributes = favoritedTrails[index].attributes;
      const geometry = favoritedTrails[index].geometry;
      const difficulty = getTrailDifficulty(attributes.DIFFICULTY);
      const icons = getIcons(attributes);
      return (
        <FeaturedRoute
          key={attributes.PRIMARY_TRAIL_ID}
          difficulty={difficulty}
          length={attributes.Length_SPC}
          attributes={attributes}
          geometry={geometry}
          icons={icons}
          setFavoritedRoutes={setFavoritedTrails}
          favoritedRoutes={favoritedTrails}
          favorited={true}
          favoriteCard={true}
          loggedIn={userInfo ? true: false}
        />
      );
    }

  };

  return (
    <>
      {!loading ?
        <>
          <div className={classes.backArrowFlex} >
            <ArrowBackIcon className={classes.pointer} onClick={() => {goBackToProfile()}}></ArrowBackIcon>
            <div className={classes.header}>Favorites</div>
          </div>
          <AutoSizer>
          {({ width, height }) => (
            <Virtuoso
              style={{ width, height }}
              totalCount={favoritedTrails.length}
              item={Row}
              overscan={500}
            >
            </Virtuoso>
          )}
          </AutoSizer>
        </>
      : <CircularProgress color="inherit" className={classes.loading}/>}
      
    </>
  );
};